import {connect} from 'react-redux';
import browserHistory from 'shared/history';
import ReportUserButton from '../components';

const mapDispatchToProps = (dispatch, {identifier, name}) => ({
  openModal: () =>
    browserHistory.push(
      window.location.pathname.concat(`/report/${identifier}?name=${encodeURIComponent(name)}`)
    ),
});

export default connect(null, mapDispatchToProps)(ReportUserButton);
